import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";

import CustomSelect from "@components/Forms/FormInputs/CustomSelect";

import { ICompanyTableControls } from "@store/filters/filter.types";
import { PopupActions } from "@store/popupStore";

interface ICompanyTypeSelectProperties {
  onChange: (newState: ICompanyTableControls["filters"]) => void;
  value: string[];
}

type ProfitType = "For-profit" | "Non-profit";

export default function CompanyTypeSelect({ onChange, value }: ICompanyTypeSelectProperties) {
  const defaultValues: ProfitType[] = ["For-profit"];

  const handleChange = (newValues: string[]) => {
    if (newValues.length === 0) {
      PopupActions.openAlert({
        duration: 4000,
        message: "At least one company type must be selected.",
        severity: "error",
      });
      return;
    }

    onChange({
      companyTypes: newValues,
      forProfit: newValues.includes("For-profit"),
      nonProfit: newValues.includes("Non-profit"),
    });
  };

  return (
    <CustomSelect
      clearIcon={<RestartAltRoundedIcon />}
      defaultSelectedOptions={defaultValues}
      formControlSx={{ width: "100%" }}
      getOptionLabel={(option) => option}
      isMultiSelect={true}
      onChange={handleChange}
      options={["Non-profit", "For-profit"]}
      selectedValues={value}
    />
  );
}
